/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as ClaimsIndexRouteImport } from './routes/claims/index'
import { Route as ServicesTelemedicineRouteImport } from './routes/services/telemedicine'
import { Route as ServicesPeerSupportCommunityRouteImport } from './routes/services/peerSupportCommunity'
import { Route as ServicesLegalTravelAssistanceRouteImport } from './routes/services/legalTravelAssistance'
import { Route as ServicesHealthcareNavigationRouteImport } from './routes/services/healthcareNavigation'
import { Route as FaqQuestionsRouteImport } from './routes/faq/questions'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as FaqDocumentsIndexRouteImport } from './routes/faq/documents/index'
import { Route as FaqDocumentsSubmittingAClaimRouteImport } from './routes/faq/documents/submittingAClaim'
import { Route as FaqDocumentsSeeingADoctorRouteImport } from './routes/faq/documents/seeingADoctor'
import { Route as FaqDocumentsMentalHealthAndYouRouteImport } from './routes/faq/documents/mentalHealthAndYou'

const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClaimsIndexRoute = ClaimsIndexRouteImport.update({
  id: '/claims/',
  path: '/claims/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesTelemedicineRoute = ServicesTelemedicineRouteImport.update({
  id: '/services/telemedicine',
  path: '/services/telemedicine',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesPeerSupportCommunityRoute =
  ServicesPeerSupportCommunityRouteImport.update({
    id: '/services/peerSupportCommunity',
    path: '/services/peerSupportCommunity',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesLegalTravelAssistanceRoute =
  ServicesLegalTravelAssistanceRouteImport.update({
    id: '/services/legalTravelAssistance',
    path: '/services/legalTravelAssistance',
    getParentRoute: () => rootRouteImport,
  } as any)
const ServicesHealthcareNavigationRoute =
  ServicesHealthcareNavigationRouteImport.update({
    id: '/services/healthcareNavigation',
    path: '/services/healthcareNavigation',
    getParentRoute: () => rootRouteImport,
  } as any)
const FaqQuestionsRoute = FaqQuestionsRouteImport.update({
  id: '/faq/questions',
  path: '/faq/questions',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqDocumentsIndexRoute = FaqDocumentsIndexRouteImport.update({
  id: '/faq/documents/',
  path: '/faq/documents/',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqDocumentsSubmittingAClaimRoute =
  FaqDocumentsSubmittingAClaimRouteImport.update({
    id: '/faq/documents/submittingAClaim',
    path: '/faq/documents/submittingAClaim',
    getParentRoute: () => rootRouteImport,
  } as any)
const FaqDocumentsSeeingADoctorRoute =
  FaqDocumentsSeeingADoctorRouteImport.update({
    id: '/faq/documents/seeingADoctor',
    path: '/faq/documents/seeingADoctor',
    getParentRoute: () => rootRouteImport,
  } as any)
const FaqDocumentsMentalHealthAndYouRoute =
  FaqDocumentsMentalHealthAndYouRouteImport.update({
    id: '/faq/documents/mentalHealthAndYou',
    path: '/faq/documents/mentalHealthAndYou',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/error': typeof ErrorRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/faq/questions': typeof FaqQuestionsRoute
  '/services/healthcareNavigation': typeof ServicesHealthcareNavigationRoute
  '/services/legalTravelAssistance': typeof ServicesLegalTravelAssistanceRoute
  '/services/peerSupportCommunity': typeof ServicesPeerSupportCommunityRoute
  '/services/telemedicine': typeof ServicesTelemedicineRoute
  '/claims/': typeof ClaimsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/faq/documents/mentalHealthAndYou': typeof FaqDocumentsMentalHealthAndYouRoute
  '/faq/documents/seeingADoctor': typeof FaqDocumentsSeeingADoctorRoute
  '/faq/documents/submittingAClaim': typeof FaqDocumentsSubmittingAClaimRoute
  '/faq/documents/': typeof FaqDocumentsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/error': typeof ErrorRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/faq/questions': typeof FaqQuestionsRoute
  '/services/healthcareNavigation': typeof ServicesHealthcareNavigationRoute
  '/services/legalTravelAssistance': typeof ServicesLegalTravelAssistanceRoute
  '/services/peerSupportCommunity': typeof ServicesPeerSupportCommunityRoute
  '/services/telemedicine': typeof ServicesTelemedicineRoute
  '/claims': typeof ClaimsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/faq/documents/mentalHealthAndYou': typeof FaqDocumentsMentalHealthAndYouRoute
  '/faq/documents/seeingADoctor': typeof FaqDocumentsSeeingADoctorRoute
  '/faq/documents/submittingAClaim': typeof FaqDocumentsSubmittingAClaimRoute
  '/faq/documents': typeof FaqDocumentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/error': typeof ErrorRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/faq/questions': typeof FaqQuestionsRoute
  '/services/healthcareNavigation': typeof ServicesHealthcareNavigationRoute
  '/services/legalTravelAssistance': typeof ServicesLegalTravelAssistanceRoute
  '/services/peerSupportCommunity': typeof ServicesPeerSupportCommunityRoute
  '/services/telemedicine': typeof ServicesTelemedicineRoute
  '/claims/': typeof ClaimsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/faq/documents/mentalHealthAndYou': typeof FaqDocumentsMentalHealthAndYouRoute
  '/faq/documents/seeingADoctor': typeof FaqDocumentsSeeingADoctorRoute
  '/faq/documents/submittingAClaim': typeof FaqDocumentsSubmittingAClaimRoute
  '/faq/documents/': typeof FaqDocumentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/error'
    | '/auth/verify'
    | '/faq/questions'
    | '/services/healthcareNavigation'
    | '/services/legalTravelAssistance'
    | '/services/peerSupportCommunity'
    | '/services/telemedicine'
    | '/claims/'
    | '/dashboard/'
    | '/profile/'
    | '/faq/documents/mentalHealthAndYou'
    | '/faq/documents/seeingADoctor'
    | '/faq/documents/submittingAClaim'
    | '/faq/documents/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/error'
    | '/auth/verify'
    | '/faq/questions'
    | '/services/healthcareNavigation'
    | '/services/legalTravelAssistance'
    | '/services/peerSupportCommunity'
    | '/services/telemedicine'
    | '/claims'
    | '/dashboard'
    | '/profile'
    | '/faq/documents/mentalHealthAndYou'
    | '/faq/documents/seeingADoctor'
    | '/faq/documents/submittingAClaim'
    | '/faq/documents'
  id:
    | '__root__'
    | '/'
    | '/error'
    | '/auth/verify'
    | '/faq/questions'
    | '/services/healthcareNavigation'
    | '/services/legalTravelAssistance'
    | '/services/peerSupportCommunity'
    | '/services/telemedicine'
    | '/claims/'
    | '/dashboard/'
    | '/profile/'
    | '/faq/documents/mentalHealthAndYou'
    | '/faq/documents/seeingADoctor'
    | '/faq/documents/submittingAClaim'
    | '/faq/documents/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ErrorRoute: typeof ErrorRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  FaqQuestionsRoute: typeof FaqQuestionsRoute
  ServicesHealthcareNavigationRoute: typeof ServicesHealthcareNavigationRoute
  ServicesLegalTravelAssistanceRoute: typeof ServicesLegalTravelAssistanceRoute
  ServicesPeerSupportCommunityRoute: typeof ServicesPeerSupportCommunityRoute
  ServicesTelemedicineRoute: typeof ServicesTelemedicineRoute
  ClaimsIndexRoute: typeof ClaimsIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  FaqDocumentsMentalHealthAndYouRoute: typeof FaqDocumentsMentalHealthAndYouRoute
  FaqDocumentsSeeingADoctorRoute: typeof FaqDocumentsSeeingADoctorRoute
  FaqDocumentsSubmittingAClaimRoute: typeof FaqDocumentsSubmittingAClaimRoute
  FaqDocumentsIndexRoute: typeof FaqDocumentsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/claims/': {
      id: '/claims/'
      path: '/claims'
      fullPath: '/claims/'
      preLoaderRoute: typeof ClaimsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/telemedicine': {
      id: '/services/telemedicine'
      path: '/services/telemedicine'
      fullPath: '/services/telemedicine'
      preLoaderRoute: typeof ServicesTelemedicineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/peerSupportCommunity': {
      id: '/services/peerSupportCommunity'
      path: '/services/peerSupportCommunity'
      fullPath: '/services/peerSupportCommunity'
      preLoaderRoute: typeof ServicesPeerSupportCommunityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/legalTravelAssistance': {
      id: '/services/legalTravelAssistance'
      path: '/services/legalTravelAssistance'
      fullPath: '/services/legalTravelAssistance'
      preLoaderRoute: typeof ServicesLegalTravelAssistanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/healthcareNavigation': {
      id: '/services/healthcareNavigation'
      path: '/services/healthcareNavigation'
      fullPath: '/services/healthcareNavigation'
      preLoaderRoute: typeof ServicesHealthcareNavigationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/questions': {
      id: '/faq/questions'
      path: '/faq/questions'
      fullPath: '/faq/questions'
      preLoaderRoute: typeof FaqQuestionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/documents/': {
      id: '/faq/documents/'
      path: '/faq/documents'
      fullPath: '/faq/documents/'
      preLoaderRoute: typeof FaqDocumentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/documents/submittingAClaim': {
      id: '/faq/documents/submittingAClaim'
      path: '/faq/documents/submittingAClaim'
      fullPath: '/faq/documents/submittingAClaim'
      preLoaderRoute: typeof FaqDocumentsSubmittingAClaimRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/documents/seeingADoctor': {
      id: '/faq/documents/seeingADoctor'
      path: '/faq/documents/seeingADoctor'
      fullPath: '/faq/documents/seeingADoctor'
      preLoaderRoute: typeof FaqDocumentsSeeingADoctorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/documents/mentalHealthAndYou': {
      id: '/faq/documents/mentalHealthAndYou'
      path: '/faq/documents/mentalHealthAndYou'
      fullPath: '/faq/documents/mentalHealthAndYou'
      preLoaderRoute: typeof FaqDocumentsMentalHealthAndYouRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ErrorRoute: ErrorRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  FaqQuestionsRoute: FaqQuestionsRoute,
  ServicesHealthcareNavigationRoute: ServicesHealthcareNavigationRoute,
  ServicesLegalTravelAssistanceRoute: ServicesLegalTravelAssistanceRoute,
  ServicesPeerSupportCommunityRoute: ServicesPeerSupportCommunityRoute,
  ServicesTelemedicineRoute: ServicesTelemedicineRoute,
  ClaimsIndexRoute: ClaimsIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  FaqDocumentsMentalHealthAndYouRoute: FaqDocumentsMentalHealthAndYouRoute,
  FaqDocumentsSeeingADoctorRoute: FaqDocumentsSeeingADoctorRoute,
  FaqDocumentsSubmittingAClaimRoute: FaqDocumentsSubmittingAClaimRoute,
  FaqDocumentsIndexRoute: FaqDocumentsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
